<template>


<va-card class="flex xs12 sm12 lg12" >
  <p class="display-3 text-center">   {{$t('arealuno.Matriculas')}}</p>
     
    <div class="row flex">

        <transition name="fade" mode="out-in">

      <div class="md6 offset--md3">
      
          <va-data-table
          :fields="fields"
          :data="AllMatriculaAluno"
          hoverable
          no-pagination
          > 
              <template slot="marker" slot-scope="props">
                <va-icon name="fa fa-circle" :color="props.rowData.color" size="8px" />
              </template>
              <template  slot="actions" slot-scope="props">
                <va-button  small color="blurple" @click="trocar_component(props.rowData)" class="ma-0">
                  Entrar
                </va-button>
            
              </template>
              
        </va-data-table>

      </div>


     </transition>

    </div>

</va-card>



</template>

<script>

export default {
  name: '',

  data () {
      return {
          showModal: false,
          disciplina: {
            id: this.$store.state.datamateria.setmateria.id,
            tipo_arquivo_id: 1,
          },
          ofertaArquivo: {}

      }
    },
    created(){
      this.all();
    },
  computed: {

    AllMatriculaAluno (){ return   this.$store.state.alunos.allmatriculaaluno },
    
    fields () {
        return [{
          name: '__slot:marker',
          width: '30px',
          dataClass: 'text-center',
        }, {
          name: 'nome_curso',
          title: this.$t('tables.headings.name'),
        },{
          name: 'acion',
          dataClass: 'text-right',
          title: 'lista',
         
        }, {
          name: '__slot:actions',
          dataClass: 'text-right',
        }]
    },
  
  },

  methods: {
   
   async all() {
      let value = ""
     await this.$store.dispatch('setMateria',value)
     this.$store.dispatch('allMatriculaAlunoPortal',this.$store.state.alunos.get_aluno.id)
     
    },
   async trocar_component(value){
        // console.log(value)
        await this.$store.dispatch('setarGradeCurricular',value)
         await this.$store.dispatch('getGradeCurricular',value.oferta_grade_empresa_id)
        await  this.$store.dispatch('allDatamateria',this.$store.state.gradecurricular.dados_gradecurricular.id)
        
          this.$router.push({ name: 'alunos/home' })
    }

  },
   
}
</script>

<style lang="scss" scoped>



.borda 
{
  border-right: 1px solid black;
}
/* Enter and leave animations can use different */
/* durations and timing functions.              */
.slide-fade-enter-active {
  transition: all 1s ease;
}

.slide-fade-enter /*.slide-fade-leave-to*/
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}


// daqui para baixo é do modal
 .modal {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .5s ease;
  
  
  &-wrapper {
   // display: table-cell;
    vertical-align: middle;
  }
  
  &-container {
    background: #fff;
    width: 950px;
    min-height: 400px;
    border-radius: 5px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0);
  //  transition: all .3s ease;
    margin:  auto;
    margin-top: 100px;
    padding: 20px 30px;
  }
  
  &-footer {
    margin-top: 15px;
  }
  
  &-enter, &-leave {
    opacity: 0;
  }
  
  &-enter &-container,
  &-leave &-container {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
  }
}

</style>